var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 35,
    viewBox: "0 0 52 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 34,
    rx: 7.5,
    fill: "#FD6727"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 34,
    rx: 7.5,
    stroke: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.513 19.6897C9.73964 20.7199 8.76266 21.1671 7.52787 21.1671C5.49258 21.1671 4 19.649 4 17.7512C4 15.8399 5.53315 14.3217 7.54152 14.3217C8.68134 14.3217 9.69888 14.8505 10.3096 15.6365L9.06121 16.7347C8.70844 16.2737 8.17919 15.9484 7.54152 15.9484C6.52378 15.9484 5.76384 16.7481 5.76384 17.7512C5.76384 18.7815 6.51033 19.5405 7.58208 19.5405C8.30127 19.5405 8.87127 19.1068 9.15618 18.673L10.513 19.6897Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0423 21.0317H11.2785V11H13.0423V14.9318C13.5308 14.5522 14.155 14.3219 14.8334 14.3219C15.7426 14.3219 16.5702 14.7285 17.1131 15.3789C17.5472 15.8942 17.7915 16.5583 17.7915 17.6835V21.0317H16.0275V17.5479C16.0275 16.8973 15.8781 16.5583 15.6341 16.3144C15.4033 16.0841 15.0505 15.9483 14.6435 15.9483C13.8972 15.9483 13.2865 16.4229 13.0423 16.7617V21.0317Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1098 16.8973C23.0556 16.3145 22.5264 15.745 21.8072 15.745C21.0744 15.745 20.4774 16.3008 20.3959 16.8973H23.1098ZM24.7516 19.9878C24.1139 20.7469 23.0691 21.1671 22.0515 21.1671C20.0839 21.1671 18.605 19.8117 18.605 17.7512C18.605 15.9213 19.8532 14.3217 21.8072 14.3217C23.6254 14.3217 24.9144 15.8535 24.9144 17.6834C24.9144 17.8597 24.901 18.036 24.8737 18.185H20.3146C20.4096 19.1068 21.1559 19.7437 22.0921 19.7437C22.8384 19.7437 23.4355 19.3237 23.7477 18.9849L24.7516 19.9878Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7066 18.7273C30.3673 19.2153 29.7839 19.5406 29.1191 19.5406C28.1284 19.5406 27.3822 18.7814 27.3822 17.7513C27.3822 16.8024 28.0471 15.9483 29.0783 15.9483C29.7568 15.9483 30.3402 16.2737 30.7066 16.7617V18.7273ZM30.8285 14.4105V14.986C30.3129 14.566 29.6479 14.3219 28.9018 14.3219C27.1107 14.3219 25.6723 15.8129 25.6723 17.7513C25.6723 18.6459 25.9843 19.4592 26.4999 20.0555C27.0834 20.7334 28.0198 21.1671 28.9966 21.1671C29.6616 21.1671 30.2314 20.9775 30.7606 20.5708V24.4438H32.5247V14.4105H30.8285Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8451 14.4105V21.0316H38.1489V20.5029C37.6333 20.9638 37.0093 21.1672 36.3714 21.1672C35.4623 21.1672 34.6482 20.7468 34.1326 20.1098C33.7119 19.5947 33.4676 18.917 33.4676 17.941V14.4105H35.2316V18.0088C35.2316 18.6053 35.3537 18.9033 35.5573 19.1338C35.8287 19.4321 36.2086 19.5406 36.5477 19.5406C37.294 19.5406 37.8369 19.0391 38.0813 18.7272V14.4105H39.8451Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1954 16.8973C45.1412 16.3145 44.612 15.745 43.8928 15.745C43.1599 15.745 42.563 16.3008 42.4815 16.8973H45.1954ZM46.8372 19.9878C46.1995 20.7469 45.1547 21.1671 44.1369 21.1671C42.1695 21.1671 40.6904 19.8117 40.6904 17.7512C40.6904 15.9213 41.9388 14.3217 43.8928 14.3217C45.711 14.3217 47 15.8535 47 17.6834C47 17.8597 46.9866 18.036 46.9593 18.185H42.4002C42.4952 19.1068 43.2414 19.7437 44.1777 19.7437C44.924 19.7437 45.5211 19.3237 45.8331 18.9849L46.8372 19.9878Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPreview);
export default __webpack_public_path__ + "static/media/CheckPreview.41975e7e83b11c6cdbc3ede93c8c9843.svg";
export { ForwardRef as ReactComponent };